"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppEventRequestDetailsNext = exports.AppEventRequestDetailsV6 = exports.AppEventRequestDetailsV5 = void 0;
const AppEventRequestDetails_1 = require("./V5/AppEventRequestDetails");
exports.AppEventRequestDetailsV5 = AppEventRequestDetails_1.default;
const AppEventRequestDetails_2 = require("./V6/AppEventRequestDetails");
exports.AppEventRequestDetailsV6 = AppEventRequestDetails_2.default;
const AppEventRequestDetails_3 = require("./V6/AppEventRequestDetails");
exports.AppEventRequestDetailsNext = AppEventRequestDetails_3.default;
//# sourceMappingURL=AppEventRequestDetails.js.map


// WEBPACK FOOTER //
// ../../Alme/AppEventRequestDetails.ts